import { Loader2 } from "lucide-react";
import { ServiceChooser } from "./ServiceChooser";

/** "What do you need a price for?" — the three services, and nothing else. */
export const ServicePicker = ({ service, bootstrapping, onSelect }) => (
  <section className="mx-auto max-w-6xl px-4 pt-10 sm:px-6 sm:pt-12">
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="text-2xl font-bold text-foreground sm:text-[30px]">
          What do you need a price for?
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">
          Choose one and we'll only ask the questions that matter for it.
        </p>
      </div>
      {bootstrapping ? (
        <span className="flex items-center gap-2 text-xs text-muted-foreground">
          <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />
          Checking for a saved quote…
        </span>
      ) : null}
    </div>
    <div className="mt-6">
      <ServiceChooser selected={service} onSelect={onSelect} />
    </div>
  </section>
);
